import BridgeManualDownload from "./BridgeManualDownload";

export default BridgeManualDownload;
